import { forwardRef, useEffect } from "react";
import {
  BsAward,
  BsPersonCheck,
  BsGraphUpArrow,
  BsShieldCheck,
} from "react-icons/bs";
import "./Highlights.css";
import AOS from "aos";

const Highlights = forwardRef((_, ref) => {

  useEffect(() => {
    AOS.init({
      duration: 2000,
    });
  }, []);
  
  const highlights = [
    {
      icon: <BsAward size={45} className="icon-highlight" />,
      text: "Más de 20 años de experiencia en el rubro",
    },
    {
      icon: <BsPersonCheck size={45} className="icon-highlight" />,
      text: "Atención personalizada y cercana",
    },
    {
      icon: <BsGraphUpArrow size={45} className="icon-highlight" />,
      text: "Resultados reales, con cientos de clientes satisfechos",
    },
    {
      icon: <BsShieldCheck size={45} className="icon-highlight" />,
      text: "Trabajo 100% legal, claro y transparente",
    },
  ];

  return (
    <div ref={ref} className="container-fluid px-3 px-md-4 py-5 my-5" id={1}>
      <div
        className="highlights-heading"
        data-aos="zoom-out-down"
        data-aos-once="true"
      >
        <span className="title-section">¿Por qué elegirnos?</span>
      </div>
      <div data-aos="fade-up" data-aos-once="true" className="row">
        {highlights.map((item, index) => (
          <div
            className={`col-12 col-md-3 d-flex flex-column align-items-center ${
              index !== highlights.length - 1 ? "border-end-desktop" : ""
            }`}
            key={index}
          >
            <div className="highlight-wrapper w-100 h-100 p-3 d-flex flex-column align-items-center">
              <div className="highlight-card d-flex flex-column align-items-center justify-content-center text-center w-100 h-100">
                {item.icon}
                <p className="m-0 fw-semibold">{item.text}</p>
              </div>

              {index !== highlights.length - 1 && (
                <div className="highlight-separator mt-3"></div>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
});

export default Highlights;
